// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qRTKr","content":"styles_content__R2yWu"};